interface GearWithCircuits2SVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearWithCircuits2SVG = ({ color, style }: GearWithCircuits2SVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
  >
    <g clipPath="url(#clip0_955_12416)">
      <path
        d="M24.8047 9.85629H27.8762V0.724141C26.8698 0.596827 25.8452 0.530518 24.8047 0.530518C23.7643 0.530518 22.7396 0.596827 21.7333 0.724141L20.1976 4.14041C18.7824 4.45074 17.4197 4.90164 16.125 5.47986L12.899 3.63115C12.0106 4.12715 11.1431 4.68415 10.3019 5.30215C9.46064 5.92016 8.6692 6.58325 7.93017 7.28613L8.67182 10.9676C7.72313 12.0445 6.87927 13.2169 6.15596 14.4688L2.47128 14.8905C2.04149 15.8188 1.66149 16.787 1.33915 17.7869C1.01943 18.7895 0.76522 19.7948 0.571289 20.8027L3.3099 23.3383C3.23914 24.0518 3.20507 24.7733 3.20507 25.5027C3.20507 26.2321 3.23914 26.9562 3.3099 27.667L0.571289 30.2027C0.76522 31.2106 1.01943 32.2159 1.33915 33.2185C1.66149 34.2184 2.04149 35.1865 2.47128 36.1149L6.15596 36.5366C6.87927 37.7885 7.72313 38.9609 8.67182 40.0377L7.93017 43.7193C8.6692 44.4195 9.46064 45.0826 10.3019 45.7032C11.1431 46.3212 12.0106 46.8782 12.899 47.3742L16.125 45.5255C17.4197 46.1011 18.7824 46.552 20.1976 46.865L21.7333 50.2812C22.7396 50.4086 23.7643 50.4722 24.8047 50.4722C25.8452 50.4722 26.8698 50.4059 27.8762 50.2812V41.1491H24.8047C16.2666 41.1491 9.34533 34.1442 9.34533 25.5053C9.34533 16.8665 16.2666 9.8616 24.8047 9.8616V9.85629Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M39.394 39.4887C41.0895 39.4887 42.4628 38.0962 42.4628 36.3801C42.4628 34.664 41.0895 33.2715 39.394 33.2715C37.6984 33.2715 36.3225 34.664 36.3225 36.3801C36.3225 38.0962 37.6957 39.4887 39.394 39.4887Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M39.394 17.7285C41.0895 17.7285 42.4628 16.336 42.4628 14.6199C42.4628 12.9039 41.0895 11.5114 39.394 11.5114C37.6984 11.5114 36.3225 12.9039 36.3225 14.6199C36.3225 16.336 37.6957 17.7285 39.394 17.7285Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M46.4042 28.6085C48.1024 28.6085 49.4756 27.216 49.4756 25.4999C49.4756 23.7839 48.1024 22.3914 46.4042 22.3914C44.706 22.3914 43.3328 23.7839 43.3328 25.4999C43.3328 27.216 44.7086 28.6085 46.4042 28.6085Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4907 25.5H43.3329"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M17.802 31.7172H28.2087L31.2802 36.3801H36.3197"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.3197 14.6199H31.2802L28.2087 19.2828H17.802"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M20.1136 10.5909V13.0683C20.1136 15.4501 19.2409 17.6251 17.8022 19.2855C16.3634 20.9458 15.4907 23.1208 15.4907 25.5026C15.4907 27.8845 16.3634 30.0594 17.8022 31.7198C19.2409 33.3802 20.1136 35.5552 20.1136 37.937V40.4143"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M32.4832 45.5229H35.5546"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M32.4832 5.47717H35.5546"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_12416">
        <rect width="50" height="51" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GearWithCircuits2SVG;
